module.exports = __webpack_public_path__ + "static/media/NunitoSans-Italic.2d517b40.ttf";